/** Human-readable source host from a news link, e.g. "salute.gov.it". */
export function sourceHost(link: string): string | null {
  try {
    return new URL(link).hostname.replace(/^www\./, '');
  } catch {
    return null;
  }
}
